import styled from 'styled-components';

import { GhostButton, BUTTON_SIZES } from 'ui/button';
import { spacing } from 'ui/theme';

import { DebouncedSearchInput } from '../../components/DebouncedSearchInput';
import { FiltersMenu } from '../components/FiltersMenu';
import { SubscriptionsButton } from '../components/SubscriptionsButton';
import { useFiltersContext } from '../contexts/FiltersContext';

const displayText = {
  placeholder: 'Search subscriptions',
  clear: 'Clear',
};

const Wrapper = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const Actions = () => {
  const { search, setSearch, clearFilters } = useFiltersContext();
  return (
    <Wrapper>
      {clearFilters && (
        <GhostButton tabIndex={0} onClick={clearFilters} size={BUTTON_SIZES.LARGE}>
          {displayText.clear}
        </GhostButton>
      )}
      <SubscriptionsButton />
      <FiltersMenu />
      <DebouncedSearchInput
        id="subscriptions-search"
        onChange={setSearch}
        value={search}
        placeholder={displayText.placeholder}
      />
    </Wrapper>
  );
};
